import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { isEmpty, isNil } from 'ramda'
import { Skeleton } from '@material-ui/lab'
import { Typography, makeStyles } from '@material-ui/core'

import Avatars from 'app/componentV4/Avatar/Avatars'
import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'

const useStyles = makeStyles({
  root: {
    '& .MuiDialog-paper': {
      width: '350px',
      maxHeight: '500px',
      overflowX: 'auto',
      padding: '2.5rem',
    },
  },
})

const Voters = (props) => {
  const { data, isOpen, onClose, isLoading, isAnonymous } = props
  const { title, votes, subscribers = [] } = data

  const classes = useStyles()
  const { formatMessage } = useIntl()

  return (
    <SimpleDialog
      id={'metrics-subscriber-list'}
      open={isOpen}
      title={
        <>
          {isLoading ? (
            <div className="w-full">
              <Skeleton
                animation="wave"
                variant="text"
                className="w-full h-32"
              />
              <Skeleton animation="wave" variant="text" className="h-3" />
            </div>
          ) : (
            <div className="my-auto">
              <Typography className="text-18 font-bold text-primary">
                {title}
              </Typography>
              <Typography className="text-10 text-neutrals-400">
                {formatMessage(
                  { id: 'label.count.vote' },
                  {
                    count: votes,
                  },
                )}
              </Typography>
            </div>
          )}
        </>
      }
      onClose={onClose}
      className={classes.root}
    >
      {isLoading ? (
        <div className="flex space-x-2 mt-10">
          <Skeleton animation="wave" variant="circle" className="w-40 h-40" />
          <div className="w-5/6">
            <Skeleton animation="wave" variant="text" className="h-32" />
            <Skeleton animation="wave" variant="text" className="h-3" />
          </div>
        </div>
      ) : (
        <div>
          {isEmpty(subscribers) ? (
            <div className="mt-10">
              <Typography className="text-14 text-grey-400">
                {isAnonymous
                  ? formatMessage({ id: 'poll.voter.anonymous' })
                  : formatMessage({ id: 'poll.no.voter' })}
              </Typography>
            </div>
          ) : (
            <>
              {subscribers.map((subscriber, index) => (
                <div
                  className="flex space-x-2 mt-10"
                  key={`subscriber-list-${index}`}
                >
                  <Avatars
                    id={subscriber.id}
                    name={`${subscriber.firstName} ${subscriber.lastName}`}
                    src={subscriber.avatar}
                    characters={subscriber.avatarCharacters}
                  />
                  <div className="m-auto">
                    <Typography className="text-16">{`${subscriber.firstName} ${subscriber.lastName}`}</Typography>
                    {isNil(subscriber.voteDate) ? null : (
                      <Typography className="text-10 text-neutrals-400">
                        {moment(subscriber.voteDate).format('MMM DD, YYYY LT')}
                      </Typography>
                    )}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </SimpleDialog>
  )
}

const valuePropTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  votes: PropTypes.number,
  subscribers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      profilePicture: PropTypes.string,
      avatarCharacters: PropTypes.string,
      lastSeen: PropTypes.string,
    }),
  ),
}
Voters.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)),
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isAnonymous: PropTypes.bool,
}

export default Voters
